import type { PlayerBonus, PlayerFreespin } from 'api/common';
import { BonusStage } from 'api/common';

const ACTIVATED_BONUS_STAGES: BonusStage[] = [
  BonusStage.HandleBets,
  BonusStage.WagerDone,
];

const isCashBonus = (
  bonus: PlayerBonus | PlayerFreespin
): bonus is PlayerBonus => 'amountCents' in bonus;

const isWagerFreeCash = (
  bonus: PlayerBonus | PlayerFreespin
): bonus is PlayerBonus =>
  isCashBonus(bonus) && bonus.amountWagerRequirementCents === 0;

export const isWagerFreeActivatedCash = (
  bonus: PlayerBonus | PlayerFreespin
): bonus is PlayerBonus =>
  isWagerFreeCash(bonus) && ACTIVATED_BONUS_STAGES.includes(bonus.stage);

const isWagerFreeCashAwaitingAutoActivation = (
  bonus: PlayerBonus | PlayerFreespin
): bonus is PlayerBonus =>
  isWagerFreeCash(bonus) &&
  bonus.stage === BonusStage.Issued &&
  !bonus.activatable;

export const isSilentWagerFreeCash = (bonus: PlayerBonus | PlayerFreespin) =>
  isWagerFreeActivatedCash(bonus) ||
  isWagerFreeCashAwaitingAutoActivation(bonus);
